export const GetDashboardDataConst = "GetDashboardData";
